<template>
    <v-navigation-drawer
      width="200"
      class="navigationdrawer"
      app
      dark
      :clipped="drawer.clipped"
      :fixed="drawer.fixed"
      :permanent="drawer.permanent"
      :mini-variant="drawer.mini"
      v-model="drawer.open"
    >
      <v-list>
        <v-list-tile @click="toggleMiniDrawer">
          <v-list-tile-action><v-toolbar-side-icon></v-toolbar-side-icon></v-list-tile-action>
          <v-list-tile-content><v-list-tile-title>OCA admin</v-list-tile-title></v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <v-list-tile v-for="(menu, index) in menuOptions" :key="index" :to="{path: '/' + menu.href}" v-if="menu.show">
            <v-list-tile-action ><v-icon>{{menu.icon}}</v-icon></v-list-tile-action>
            <v-list-tile-content ><v-list-tile-title>{{menu.title}}</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>

        <v-list-tile @click="logout"  style="cursor: pointer">
            <v-list-tile-action ><v-icon>arrow_right_alt</v-icon></v-list-tile-action>
            <v-list-tile-content ><v-list-tile-title>Ausloggen</v-list-tile-title>
            </v-list-tile-content>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>
</template>

<script>
import axios from 'axios'
  export default {
    data () {
      return {
        drawer: {
          open: true,
          clipped: false,
          fixed: false,
          permanent: true,
          mini: false
        }
      }
    },
    methods: {
      logout(){
        axios.get('logout.php')
        .then(response => {
          this.$cookie.delete('x-access-token')
          this.$cookie.delete('admin')
          this.$router.push('/')
        })
        .catch(e => {
          console.error(e)
        })
      },
      toggleMiniDrawer () {
      this.drawer.mini = !this.drawer.mini
    }
  },
  computed: {
    menuOptions () {
      return [
        { title: 'Tests', icon: 'dashboard', href: 'tests', show: true },
        { title: 'Anmelden', icon: 'group', href: 'signup', show: this.$router.app.$cookie.get('admin') == 1},
        { title: 'Websites', icon: 'fingerprint', href: 'websites', show: this.$router.app.$cookie.get('admin') == 1},
        { title: this.lang.megbizottak, icon: 'assignment', href: 'assignees', show: this.$router.app.$cookie.get('admin') == 1}
      ]
    }
  }
  }
</script>



<!-- <template id="">
  <v-toolbar dark color="primary">
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-sm-and-down">
      <v-btn flat to='/tests'>Tesztek</v-btn>
      <v-btn flat @click="logout">Logout</v-btn>
      <v-btn flat to='/signup'>Sign up</v-btn>
      <v-btn flat @click="chagePass">Change password</v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import axios from 'axios';
  export default {
    data () {
      return {
        drawer: true,
       items: [
         { title: 'Tests', icon: 'dashboard', to: '/tests' },
         { title: 'Sign up', icon: 'settings', to: '/signup' }
       ],
       mini: true,
       right: null
      }
    },
    created() {
    },
    methods: {
      logout(){
        axios.get('logout.php')
        .then(response => {
          this.$cookie.delete('x-access-token')
          this.$router.push('/')
        })
        .catch(e => {
          console.error(e)
        })
      },
      chagePass(){
        //     axios.get('changepass.php')
        //     .then(response => {
        //       this.$emit('myEvent')
        //     })
        //     .catch(e => {
        //       console.error(e)
        //     })
        // this.$emit('myEvent')
      }
    }
  }
</script> -->
